import setupMqtt from './setup';
import { MQTT_CONNECT, MQTT_SUBSCRIBE, MQTT_UNSUBSCRIBE, MQTT_PUBLISH, MQTT_RECONNECT, } from './actions';
/**
 *
 * @param mqttRoutersMap A mapping of topics and routers that should be configured on the wrappedMqttClient. Example:
 *
 * 		```
 * 		{
 * 			'foo/#': new MqttRouter(),
 * 			'bar/#': new MqttRouter()
 * 		}
 * 		```
 */
function buildReduxMqttMiddleware(mqttClientOptions, mqttRoutersMap = {}, mqttMiddlewares = [], callbacks = {}) {
    // keeping the singleton in the scope of the middleware-creator,
    //   guarantees that there will only be one instance of it ever!!!
    let wrappedMqttClient = undefined;
    const callbacksFromReduxMiddleware = callbacks;
    /** A customized version of mqtt.Client.publish that attempts to JSON.stringify messages
     * 	before actually publishing it.
     * If the message cannot be stringified, it will be published as it is.
     */
    const mqttPublish = (topic, message, options, callback) => {
        var _a;
        let jsonStringifiedMessage = message;
        try {
            jsonStringifiedMessage = JSON.stringify(message);
        }
        catch (error) {
            console.warn(`Unable to convert mqtt message: ${message} into JSON string`);
        }
        (_a = wrappedMqttClient) === null || _a === void 0 ? void 0 : _a.mqttClient.publish(topic, jsonStringifiedMessage, (options || {}), callback);
    };
    return ({ dispatch, getState }) => next => (action) => {
        var _a, _b, _c;
        switch (action.type) {
            case MQTT_CONNECT: {
                const { username, password, callbacks, onceCallbacks } = action.payload;
                if (wrappedMqttClient === undefined) {
                    // the dispatch function will be used in the subscription handler functions,
                    // It might be necessary to dispatch an action to save a received message in the store, for instance
                    wrappedMqttClient = setupMqtt(username, password, mqttClientOptions, mqttRoutersMap, mqttMiddlewares, {
                        dispatch: dispatch,
                        getState,
                    }, Object.assign(Object.assign({}, callbacksFromReduxMiddleware), callbacks), onceCallbacks);
                }
                break;
            }
            case MQTT_RECONNECT: {
                (_a = wrappedMqttClient) === null || _a === void 0 ? void 0 : _a.mqttClient.reconnect();
                break;
            }
            case MQTT_SUBSCRIBE: {
                const { topic, handler, options } = action.payload;
                (_b = wrappedMqttClient) === null || _b === void 0 ? void 0 : _b.listen(topic, handler, options);
                break;
            }
            case MQTT_UNSUBSCRIBE: {
                const { topic } = action.payload;
                (_c = wrappedMqttClient) === null || _c === void 0 ? void 0 : _c.unlisten(topic);
                break;
            }
            case MQTT_PUBLISH: {
                const { topic, message, options, callback } = action.payload;
                mqttPublish(topic, message, options, callback);
                break;
            }
            default:
                // this middleware does not handle this action type. Forward it to the next middlewares
                return next(action);
        }
        // send out just the action type, so that is can be traced in redux devtools
        return next({ type: action.type });
    };
}
export default buildReduxMqttMiddleware;
